/**
 * @generated SignedSource<<cd60b82e8fa3f9ac9986ac0ab8a43618>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountView_bankAccount$data = {
  readonly accountHolderName: string | null;
  readonly accountType: string | null;
  readonly display: string | null;
  readonly " $fragmentType": "CheckoutBankAccountView_bankAccount";
};
export type CheckoutBankAccountView_bankAccount$key = {
  readonly " $data"?: CheckoutBankAccountView_bankAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountView_bankAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountView_bankAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "display",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountHolderName",
      "storageKey": null
    }
  ],
  "type": "ACH",
  "abstractKey": null
};

(node as any).hash = "7abf92cf26ea02934c782229f5adb3f0";

export default node;
